import React from "react"
import { Trans } from "@lingui/macro"
import clsx from "clsx"
import { SanitySuite } from "../../app-core/_common/sanity/sanity-types"
import styles from "./ShipDetails.module.scss"

type Props = {
    suitesContent: readonly SanitySuite[]
}

const SuiteCategories: React.FC<Props> = ({ suitesContent }) => (
    <div className={styles.section}>
        <div className={styles.subTitle}>
            <Trans>Suite categories</Trans>
        </div>
        <div className={clsx(styles.categoriesLegend, styles.sectionContent)}>
            {suitesContent.map((x) => (
                <div key={x.card.title} className={styles.categoryLegend}>
                    <div className={styles.categoryColorLegend} style={{ backgroundColor: `#${x.color}` }}></div>
                    <div>{x.card.title}</div>
                </div>
            ))}
        </div>
    </div>
)

export default SuiteCategories
